// React
import React from 'react';

// Vendors
import { Link } from 'react-router-dom';
import { Button, Icon, UserProfile } from '@equisoft/design-elements-react';
import { useTranslation } from 'react-i18next';

// Src
import { ReactComponent as Logo } from '@/assets/logo-equisoft.svg';
import { useAuthentication } from '@/domain/authentication/hooks/useAuthentication';
import { useAppDispatch } from '@/infrastructure/redux/hooks/useAppDispatch';
import { logoutRequestAction } from '@/domain/authentication/reducers/authenticationReducer';
import Dropdown from '@/application/components/Dropdown/Dropdown';

// Styles
import classes from './TheHeader.module.scss';

const TheHeader = () => {
    // Hooks
    const { t, i18n } = useTranslation();
    const { user } = useAuthentication();
    const dispatch = useAppDispatch();

    // Variables
    const currentLanguage = i18n.language;

    // Handlers
    const handleLogout = () => {
        dispatch(logoutRequestAction());
    };

    return (
        <header className={classes.Root}>
            <Link
                to="/"
                className={classes.LogoWrapper}
            >
                <Logo />
                <div className={classes.LogoTitle}>{t('common.logo_title')}</div>
            </Link>

            <div className={classes.SpaceBetween} />

            <Dropdown>
                <Dropdown.Trigger>
                    {(props) => {
                        return (
                            <Button
                                buttonType="tertiary"
                                onClick={(e) => props.setAnchorEl(e.currentTarget)}
                                className={classes.SwitchLanguage}
                            >
                                {t('app.component.the_header.language')}
                                {props.anchorEl ? <Icon name="chevronUp" /> : <Icon name="chevronDown" />}
                            </Button>
                        );
                    }}
                </Dropdown.Trigger>
                <Dropdown.Menu>
                    <Dropdown.Item onClick={() => i18n.changeLanguage('en')}>
                        <Icon
                            name="check"
                            className={currentLanguage === 'en' ? classes.LanguageItemSelected : classes.LanguageItem}
                        />
                        {t('app.component.the_header.english')}
                    </Dropdown.Item>
                    <Dropdown.Item onClick={() => i18n.changeLanguage('fr')}>
                        <Icon
                            name="check"
                            className={currentLanguage === 'fr' ? classes.LanguageItemSelected : classes.LanguageItem}
                        />
                        {t('app.component.the_header.french')}
                    </Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>

            <UserProfile
                options={[
                    {
                        href: '#',
                        value: t('app.core.default_layout.logout'),
                        onClick: handleLogout,
                    },
                ]}
                username={user?.displayName || ''}
            />
        </header>
    );
};

export default TheHeader;
